import { __decorate } from "tslib";
import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { workspaceApiUrlPrefix } from '@cores/constants/envConfig';
let ReasoningApiImpl = class ReasoningApiImpl extends PsHttpService {
    get options() {
        return {
            baseURL: workspaceApiUrlPrefix,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }
    getReasoning(params) {
        const { folder_id, field_id, patent_id, signal } = params;
        return this.get({
            url: `/smart/folder/${folder_id}/field/${field_id}/reasoning`,
            transformCode: true,
            params: { patent_id },
            signal,
        }).then(res => res.data);
    }
    checkPatentWithReasoning(params) {
        const { folder_id, field_id, patent_id, save_reasoning_as_comment, comment_visible_scope } = params;
        return this.post({
            url: `/smart/folder/${folder_id}/field/${field_id}/check-patent`,
            transformCode: true,
            data: {
                patent_ids: [patent_id],
                refiner: {},
                select_mode: 'INCLUDE',
                save_reasoning_as_comment,
                comment_visible_scope,
            },
        }).then(res => res.data);
    }
};
ReasoningApiImpl = __decorate([
    injectable()
], ReasoningApiImpl);
export { ReasoningApiImpl };
